import axios from "axios";
import { setUserAsGuest } from "./auth/service";

const axiosInstance = axios.create({ baseURL: process.env.REACT_APP_API_URL });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    config.headers.Authorization = token ? `Bearer ${token}` : "";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.is_guest_user) setUserAsGuest();

    if (response.headers["content-disposition"]) {
      return {
        data: response.data,
        "content-disposition": response.headers["content-disposition"],
      };
    }

    return response.data;
  },
  ({ response }) => {
    let error = null;
    let property = null;

    if (response && response.data) {
      error = response.data.errors || response.data.error || null;
      property = response.data.property || null;
    }

    if (response.status == 406) {
      error = response.data;
      error.status = response.status;
    }

    if (response.status == 400) {
      error = response.data.errors || response.data.error;
      property = response.data.property;
      status = 400;
    } else {
      if (!error) error = "Something went wrong. Please try again";
    }

    if (error === "Unauthorized") {
      setUserAsGuest();

      if (
        ![
          "/products",
          "/materials_price?type=boards&token=925b4b62202d",
        ].includes(response.config.url)
      )
        window.location.href = "/login_with_otp";
      error = "Please log in to continue";
    }

    return Promise.reject({ error, property, status });
  }
);

export default axiosInstance;
